import React from "react";
import "./CourseFormModal.css";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

export default function CourseFormModal({
  show,
  onHandleHide,
  btnText,
  body,
  id,
  label,
}) {
  const navigate = useNavigate();

  const handleHideModal = () => {
    onHandleHide();
  };
  const handleModalClickBtn = () => {
    if (btnText === "تکمیل فرم") {
      if (id) {
        if (
          label === "exercise both" ||
          label === "exercise medical" ||
          label === "diet medical"
        ) {
          navigate("/medicalForm", {
            state: {
              formId: id,
              planType: label === "diet medical" ? "diet" : "exercise",
            },
          });
        } else if (
          label === "exercise first month" ||
          label === "diet first month"
        ) {
          navigate("/uploadImage", {
            state: {
              id: id,
              planType: label === "exercise first month" ? "exercise" : "diet",
            },
          });
        } else if (label === "diet info") {
          navigate("/mealsForms", { state: { formId: id } });
        }
      }
    } else if (btnText === "تایید") {
      onHandleHide();
    }
  };
  return (
    <Modal className="courseFormModal" show={show} onHide={handleHideModal}>
      <Modal.Header className="courseFormModalHeader centeredFlex">
        <CloseIcon className="courseFormCloseIcon" onClick={handleHideModal} />
      </Modal.Header>
      <Modal.Body className="courseFormModalBody">
        <h4>{body}</h4>
      </Modal.Body>
      <Modal.Footer className="courseFormModalFooter">
        <button
          onClick={handleModalClickBtn}
          className="courseFormBtn nextQuestion"
        >
          {btnText}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
